import ContactsBanner from './images/ContactsBanner.jpg';
import './App.css';
import { Col, Row, Button, Typography} from 'antd';
import {NavLink} from "react-router-dom";
import Header from "./Header";
import Ship from './images/ship.jpeg';

const { Title, Text } = Typography;

function About() {
  return (
    <>
        <Header />
        <Row style={{
                maxWidth: 1024,
                margin: '24px auto 124px auto',
                textAlign: "center"
            }}>
                                   

                <Col span={24}>
                    <Title level={1} style={{marginTop: 128}}>About us</Title>
                    <Title level={4} style={{fontWeight: "normal"}}>
                        We focus on modern property management technologies tailored for co-living operations.<br/>  
                        Helping co-living businesses reduce administrative overhead, streamline <br/> tenant and room management
                    </Title>
                </Col>
            </Row>

            <Row
                style={{
                    maxWidth: 1024,
                    margin: '0 auto',
                    paddingBottom: 128
                }}
            >
                <Col span={12}>
                
                    <div style={{
                        borderRadius: 24,
                        backgroundImage: `url(${Ship})`,
                        backgroundPosition: 'right',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        height: "600px",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>It's simply because we care, everyday ...</h1>
                        </div>
                    </div>
                </Col>
                <Col
                    span={12}
                    style={{ textAlign: "left", paddingLeft: 48 }}
                    className={'cloud'}
                >
                    <Title level={1} style={{ marginBottom: 32, marginTop: 220 }}>What do we do</Title>
                    <Title level={4} style={{fontWeight: "normal" }}>We develop and maintain modern co-living management software</Title>
                </Col>
            </Row>
    </>
  );
}

export default About;